module.exports = __webpack_public_path__ + "ff0cd1a094d694888789f5f2450579eb.pdf";